import collectionReducer from '../collectionReducer';

export default collectionReducer({
    apiCollectionName: 'apmGroups',
    collectionActionName: 'APM_GROUPS',
    itemActionName: 'APM_GROUP',
});
